import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import { GetServerSideProps } from "next";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import LayoutMaster from "../components/layout/layout_master";
import AgentProfile from "components/view/agent_profile";
import HistoryAgent from "components/view/history_agent";
import AgentReward from "components/view/agent_reward";
import FriendReward from "components/view/friend_reward";

interface InviteAgentPageProps {
  state: AppReducerStateProps;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

interface SectionTypeGamesProps {
  title: string | undefined;
  toggleState: number;
}

function InviteAgentPage(props: InviteAgentPageProps) {
  const { infomation } = props;
  const [toggleState, setToggleState] = useState<number>(1);
  const [sectionTypeGames, setSectionTypeGames] = useState<
    SectionTypeGamesProps[]
  >([]);

  useEffect(() => {
    setSectionTypeGames([
      {
        title: "ตัวแทน",
        toggleState: 1,
      },
      {
        title: "ประวัติตัวแทน",
        toggleState: 4,
      },
      {
        title: "รางวัลตัวแทน",
        toggleState: 2,
      },

      {
        title: "รางวัลเชิญเพื่อน",
        toggleState: 3,
      },
    ]);
  }, []);

  const display = (): any => {
    switch (toggleState) {
      case 1:
        return (
          <>
            <AgentProfile
              isLogin={props.isLogin}
              infomation={infomation}
            ></AgentProfile>
          </>
        );
      case 2:
        return (
          <>
            <AgentReward
              isLogin={props.isLogin}
              infomation={infomation}
            ></AgentReward>
          </>
        );
      case 3:
        return (
          <>
            <FriendReward
              isLogin={props.isLogin}
              infomation={infomation}
            ></FriendReward>
          </>
        );
      case 4:
        return (
          <>
            <HistoryAgent isLogin={props.isLogin}></HistoryAgent>
          </>
        );
    }
  };

  if (!infomation.isDealer) {
    return (
      <LayoutMaster
        content_setting={{
          title: "ตัวแทน ยิ่งเชิญตัวแทนมาก ยิ่งได้เครดิตมาก",
          description:
            "รับ เคริตฟรี มากมาย จากการ เชิฐตัวแทน และท่านยังได้รับสิทธิพิเศษมากมายจากการมีตัวแทน ทำให้สามารถใช้เครดิตได้มากยิ่งขึ้น เชิญเลยง่ายๆ เพียง คลิกเดียว",
        }}
        information={props.infomation}
      ></LayoutMaster>
    );
  }

  return (
    <LayoutMaster
      content_setting={{
        title: "ตัวแทน ยิ่งเชิญตัวแทนมาก ยิ่งได้เครดิตมาก",
        description:
          "รับ เคริตฟรี มากมาย จากการ เชิฐตัวแทน และท่านยังได้รับสิทธิพิเศษมากมายจากการมีตัวแทน ทำให้สามารถใช้เครดิตได้มากยิ่งขึ้น เชิญเลยง่ายๆ เพียง คลิกเดียว",
      }}
      information={infomation}
    >
      <div className="container" style={{ paddingTop: 0 }}>
        <div>
          <div className="bg-tab-type">
            <div className="row">
              {sectionTypeGames.map((el, i) => {
                return (
                  <div
                    key={i}
                    className="col-3"
                    style={{ paddingLeft: 2, paddingRight: 2 }}
                  >
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setToggleState(el.toggleState);
                      }}
                      font-tab-
                    >
                      <div
                        style={{
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                        }}
                        className={`${
                          el.toggleState == toggleState
                            ? "btn-agent-purple"
                            : "btn-agent-non-active"
                        }  `}
                      >
                        <p
                          className="text-center"
                          style={{ padding: "10px 0px 10px 0px", fontSize: 12 }}
                        >
                          {el.title}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div style={{ paddingTop: 0, paddingLeft: 0, padding: 0 }}>
          {display()}
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(InviteAgentPage);
